import { render, staticRenderFns } from "./PricelistEditorPage.vue?vue&type=template&id=a9d459e8"
import script from "./PricelistEditorPage.vue?vue&type=script&lang=js"
export * from "./PricelistEditorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports